module.exports = __webpack_public_path__ + "static/img/cheese_2.1ef625b2.webp";